// @ts-expect-error Untyped module
import { RequestStatus } from '../constants/base';
import { REQUESTED_CMS_USER_SETTINGS, RECEIVED_CMS_USER_SETTINGS, REQUESTED_CMS_USER_SETTINGS_FAILED
// @ts-expect-error Untyped module
} from '../actions/ActionTypes';
const initialState = {
  data: {
    customDomainSetupNextReminderDate: null
  },
  status: RequestStatus.UNINITIALIZED
};
export default ((state = initialState, action) => {
  switch (action.type) {
    case REQUESTED_CMS_USER_SETTINGS:
      return Object.assign({}, state, {
        status: RequestStatus.PENDING
      });
    case RECEIVED_CMS_USER_SETTINGS:
      return Object.assign({}, state, {
        data: action.payload.userSettings,
        status: RequestStatus.SUCCEEDED
      });
    case REQUESTED_CMS_USER_SETTINGS_FAILED:
      return Object.assign({}, state, {
        status: RequestStatus.FAILED
      });
    default:
      return state;
  }
});